import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { connect } from "react-redux";
import classNames from "classnames";

import {
  setHistoryContext,
} from "../../actions/historyActions";

export function Tabs({ historyContext, setAll, setSubmitted, setTodo }) {
  return (
    <div className="row historyTitle">
      <div className="col-sm-4 col-xs-12">
        <h1>Entries</h1>
      </div>
      <div className="col-sm-8 col-xs-12 history-toggles text-right">
        <button
          className={classNames({ "btn-active": historyContext === "all" })}
          onClick={setAll}
        >All</button>
        <button
          className={classNames({ "btn-active": historyContext === "todo" })}
          onClick={setTodo}
        >To Do</button>
        <button
          className={classNames({ "btn-active": historyContext === "submitted" })}
          onClick={setSubmitted}
        >Submitted</button>
      </div>
    </div>
  );
}

Tabs.displayName = "History.Tabs";

Tabs.propTypes = {
  historyContext: PropTypes.string.isRequired,
  setAll: PropTypes.func.isRequired,
  setSubmitted: PropTypes.func.isRequired,
  setTodo: PropTypes.func.isRequired,
};

Tabs.defaultProps = {
  historyContext: "todo",
};

function mapStateToProps(state, ownProps) {
  return {
    activeFilters: state.historyFilters.activeFilters,
    historyContext: state.historyFilters.context,
    entries: state.entries.entries,
    endDate: state.historyFilters.endDate,
    hoursSubmitted: state.entries.submittedHours,
    hoursWorked: state.entries.hours,
    sortDir: state.historyFilters.sortDir,
    startDate: state.historyFilters.startDate,
    submitted: state.historyFilters.filters.submitted,
    todo: state.historyFilters.filters.todo,
    workingHours: state.settings.workingHours,
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    setAll: () => dispatch(setHistoryContext("all")),
    setSubmitted: () => dispatch(setHistoryContext("submitted")),
    setTodo: () => dispatch(setHistoryContext("todo")),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Tabs);



// WEBPACK FOOTER //
// ./app/components/History/Tabs.jsx